<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaGhe"
      option-label="name"
      option-value="id"
      label="Selecione o Ghe"
      label-color="grey-6"
      behavior="menu"
      map-options
      :bg-color="disable ? 'grey-3' : ''"
      :disable="disable"
      :rules="validacao ? [(val) => val || 'Campo Obrigatório'] : []"
      use-input
      hide-bottom-space
      @filter="filtrar"
      :display-value="
        modelValue?.name?.length > 9
          ? `${modelValue?.name.substring(0, 9)}....`
          : modelValue?.name
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="modelValue"> {{ props?.modelValue?.name }} </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
  disable: {
    type: Boolean,
  },
  validacao: {
    type: Boolean,
    default: false,
  },
});

const listaGhe = ref([]);

const listarGhe = async (val) => {
  listaGhe.value = [];
  try {
    const response = await store.dispatch("user/getFuncoes", {
      vendor_id: store.state.org.unidadeData.id,
      search: val,
    });
    listaGhe.value = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

const filtrar = async (val, update) => {
  await listarGhe(val);
  update();
};
</script>
